import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function NotificationBell({ light }) {
  const { lang } = useApp();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = () => api.get("/me/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  const onOpen = (v) => {
    setOpen(v);
    if (v && data.unread) { api.post("/me/notifications/read").then(() => setData((d) => ({ ...d, unread: 0 }))); }
  };
  return (
    <Popover open={open} onOpenChange={onOpen}>
      <PopoverTrigger className={`relative ${light ? "text-white" : ""}`} data-testid="notif-bell-btn" aria-label="Notifications">
        <Bell size={20} strokeWidth={1.5} />
        {data.unread > 0 && <span data-testid="notif-unread-count" className="absolute -top-2 -right-2 bg-[#8C4F27] text-white text-[10px] w-4 h-4 rounded-full grid place-items-center">{data.unread > 9 ? "9+" : data.unread}</span>}
      </PopoverTrigger>
      <PopoverContent align="end" className="rounded-none w-80 p-0 max-h-[70vh] overflow-y-auto" data-testid="notif-panel">
        <p className="px-4 py-3 font-mono text-xs tracking-[0.2em] text-[#8C4F27] border-b border-[#E6DFD5]">{lang === "id" ? "NOTIFIKASI" : "NOTIFICATIONS"}</p>
        {!data.items.length && <p className="px-4 py-6 text-sm text-[#6E6259]" data-testid="notif-empty">{lang === "id" ? "Belum ada notifikasi" : "No notifications yet"}</p>}
        {data.items.map((n) => (
          <button key={n.notif_id} onClick={() => { setOpen(false); nav(n.link || "/account"); }} data-testid={`notif-item-${n.notif_id}`}
            className={`w-full text-left px-4 py-3 border-b border-[#E6DFD5] hover:bg-[#F6F2EE] transition-colors ${n.read ? "" : "bg-[#FBF7F2]"}`}>
            <p className="text-sm font-medium">{n.title}</p>
            <p className="text-xs text-[#6E6259]">{n.body}</p>
            <p className="text-[10px] font-mono text-[#6E6259] mt-1">{new Date(n.created_at).toLocaleString()}</p>
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
